import React, { useEffect } from 'react'
import { getImage } from '../../../utilities/iconResolver'
import { useDispatch } from 'react-redux'
import { setWizardType } from '../onboardingSlice'
import { t } from '../../../utilities/translator'
import { WIZARD_SECOND_VISIT_ANSWERED, WIZARD_SECOND_VISIT_LOADED } from '../../../constants/analyticEvents'
import { pushEvent } from '../../../utilities/analytics'
import { isMobile } from '../../../utilities/helpers';
import abTesting from '../../../services/abTesting'

const WizardTypeSelector = () => {
  const dispatch = useDispatch()

  const handleOptionClick = (option) => {
    dispatch(setWizardType(option))
    pushEvent(WIZARD_SECOND_VISIT_ANSWERED, { option: option === 'assistant' ? 'AI assistant' : 'Feed Builder' })
  }

  useEffect(() => {
    pushEvent(WIZARD_SECOND_VISIT_LOADED)
  }, []);

  if (!isMobile()) {
    // Desktop wizard type selector
    return (
      <div className="wizard-type-step">
        <p className="mb-8 heading-large text-primary">{t('onboarding.assistant.wizardTypeTitle')}</p>
        <div className="flex gap-6 justify-center mb-8">
          <div className="wizard-button wizard-ai-button px-9 py-6 w-auto cursor-pointer slide-in-bottom animation-delay-0" onClick={() => handleOptionClick('assistant')}>
            <i className="ri-openai-line leading-none" />
            <span className="text-secondary text-sm font-semibold">{t('onboarding.assistant.aiAssistant')}</span>
          </div>
          <div className="wizard-button wizard-ai-button px-9 py-6 w-auto cursor-pointer slide-in-bottom animation-delay-100" onClick={() => handleOptionClick('wizard')}>
            <i className="ri-hand leading-none" />
            <span className="text-secondary text-sm font-semibold">{t('onboarding.assistant.feedBuilder')}</span>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="wizard-layout">
      {!abTesting.aiAssistantV2 && (
        <div className="wizard-navbar">
          <div className="wizard-navigation flex justify-center">
            <img src={getImage('HF-white-Logo.svg')} alt="" />
          </div>
        </div>
      )}

      <div className="wizard-step justify-center">
        <div className="wizard-step__title mb-1">{t('onboarding.assistant.wizardTypeTitle')}</div>
        <div className="wizard-step__options flex flex-col gap-4">
          <div className="px-5 py-4 flex flex-col items-center gap-2 rounded-xl shadow-15" onClick={() => handleOptionClick('assistant')}>
            <i className="ri-openai-line text-2xl leading-none p-2" />
            <span className="text-secondary text-sm font-semibold">{t('onboarding.assistant.aiAssistant')}</span>
          </div>
          <div className="px-5 py-4 flex flex-col items-center gap-2 rounded-xl shadow-15" onClick={() => handleOptionClick('wizard')}>
            <i className="ri-hand text-2xl leading-none p-2" />
            <span className="text-secondary text-sm font-semibold">{t('onboarding.assistant.feedBuilder')}</span>
          </div>
        </div>
      </div>
    </div>
  )
}

export default WizardTypeSelector
